// extracted by css-extract-rspack-plugin
export default {"headerRow":"_MGWtbaW3KkgpqaN","dataRow":"GJae9ILvU1jWNLM4","cell":"Mpo1aEyHuX8STEML"};